export class StreamFile {
  public path?: string;
  public fileName?: string;
  public stream?: Stream;
}
